<img *ngIf="profileAvatar; else baseAvatar" [src]="profileAvatar" [attr.width]="width" [attr.height]="height" alt="user avatar" />

<ng-template #baseAvatar>
  <img *ngIf="isIndividualAccount" src="/assets/default-avatar.svg" [attr.width]="width" [attr.height]="height" alt="user avatar" />
  <img *ngIf="!isIndividualAccount" src="/assets/default-business-avatar.svg" [attr.width]="width" [attr.height]="height" alt="user avatar" />
</ng-template>
